import BackendApiClient from '../api/BackendApiClient';

class AuthorizationManager {
  login = async (data) =>
    BackendApiClient.requestAsync({
      method: 'POST',
      url: '/staff/login',
      data,
    });
}

export default new AuthorizationManager();
